import { locationsModule } from './store/locations'
import { createModule } from '@vue-storefront/core/lib/module'

export const LOCATIONS_KEY = 'locations'
export const Locations = createModule({
  key: LOCATIONS_KEY,
  store: {
    modules: [
      {
        key: LOCATIONS_KEY,
        module: locationsModule
      }
    ]
  }
})
